import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueJwtDecode from 'vue-jwt-decode';

export default {
  name: 'RMApproveDashboard',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        searchflag:false,
        localuserid:'',
        localusermailid:'',
        hubname:'',
        hubID:[],
        hubzoneid:'',
        hubList:[],
        hubZoneList:[],
        Loading: false,
        localhubdetails: '',
        hubinfo: '',
        hubStateList : [],
        hubCitybyStateList : [],
        hubNameList : [],
        hubStateId : '',
        hubCityId : '',
        filteredHubList : [],
        usernames : '',
        userDataKey : '',
        heading: '',
        hubAccessList : [],
        selectAll: false,
        allhubList:[],
        detailsLoading:false,
        dashboardDetails:[],
        temp:[],
        rowsPerPage: 10,
        currentPage: 1,
        GrantTotalRecovedYTD:0,
        RecoveredAmountCount:0,
        GrandTotalRMApproveYTD:0,
        RMApprovalCount:0,
        zoneName:'',
      }
  },
  created: function() {
  },
async mounted(){
    let validateUser = await this.validateJwtToken();
    // this.getHubList("hubList");
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    // console.log('Mixin is working for :',userdetail);

    this.userRoleList = userdetail.userrole.map((role) => role.rolename);
    if(this.userRoleList.includes('StateHeadApproved')) {
      this.heading="StateHead Approve";
    } else if(this.userRoleList.includes('ClusterHeadApproved')) {
      this.heading="ClusterHead Approve"
    } else {
      this.heading="RM Approve"
    };
    // console.log('this.userRoleList ------>>', this.userRoleList);
    let getHubList = localStorage.getItem('allhubaccesslist');
    var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    var hubList = byteHub.toString(CryptoJS.enc.Utf8);
    this.hubAccessList = JSON.parse(hubList);
    var date = new Date();
    this.year = date.getFullYear();
    this.getDashboardDetails();
    this.getHubZoneList();
    this.getServiceCentreList("");
    this.getHubStateList();
    this.hubzoneid=this.hubZoneList[0].HubZoneId;
    this.selectedHubZoneId=this.hubZoneList[0].HubZoneId;
  },

  computed: {
        paginatedData() {
            if (!this.dashboardDetails || this.dashboardDetails.length === 0) {
                return [];
            }
            if (!this.dashboardDetails || this.dashboardDetails.length<this.rowsPerPage) {
              return this.dashboardDetails;
          }
            const start = (this.currentPage - 1) * this.rowsPerPage;
            return this.dashboardDetails.slice(start, start + this.rowsPerPage);
        },
        totalPages() {
            if (!this.dashboardDetails || this.dashboardDetails.length === 0) {
                return 0;
            }
            return Math.ceil(this.dashboardDetails.length / this.rowsPerPage);
        }
    },
  methods : {
    calculateselectedcount(){
     this.totalSelectedRecords = this.selectedItems.length
    },
    searchData() {
        console.log(this.hubzoneid, this.hubStateId,this.hubCityId)
        this.detailsLoading=true;
        if(this.hubzoneid==='' && this.hubStateId=== '' && this.hubCityId==='' && this.hubID.length===0){
          this.$alertify.error('Please select fileds for search');
          this.detailsLoading=false;
        }else{
          let hubIDarray = []
          if(this.hubID.length > 0 ){
            this.hubID.map(hub=>{
              hubIDarray.push(hub.HubID)
            })
          }
          this.currentPage=1
          this.dashboardDetails=this.temp;
          var dashboardDetails=this.dashboardDetails;
          if(this.hubzoneid!=''){
            var filteredZone=[];
            filteredZone=dashboardDetails.filter(h =>
                    h.HubZoneId==this.hubzoneid
                  )
          }
          if(this.hubzoneid!='' && this.hubStateId!=''){
            filteredZone=dashboardDetails.filter(h =>
              h.HubZoneId==this.hubzoneid &&
              h.HubStateId==this.hubStateId
            )
          }
          if(this.hubzoneid!='' && this.hubStateId!='' && this.hubCityId!=''){
            filteredZone=dashboardDetails.filter(h =>
              h.HubZoneId==this.hubzoneid &&
              h.HubStateId==this.hubStateId &&
              h.CityId==this.hubCityId
            )
          }
          if(this.hubzoneid!='' && this.hubStateId!='' && this.hubCityId!='' && hubIDarray.length!=0){
            filteredZone=dashboardDetails.filter(h =>
              h.HubZoneId==this.hubzoneid &&
              h.HubStateId==this.hubStateId &&
              h.CityId==this.hubCityId &&
              hubIDarray.includes(h.HubID)
            )
          }
          if(filteredZone.length!=0){
                this.zoneName=filteredZone[0].hubzonename;
              var totalFRytd=0, totalFRytdCount=0, totalRMAytd=0, totalRMAytdCount=0;
              filteredZone.forEach(element => {
                totalFRytd=parseFloat(totalFRytd)+parseFloat(element.FRytd);
                totalFRytdCount=parseInt(totalFRytdCount)+parseInt(element.FRytdCount);
                totalRMAytd=parseFloat(totalRMAytd)+parseFloat(element.RMAytd);
                totalRMAytdCount=parseFloat(totalRMAytdCount)+parseInt(element.RMAytdCount);
              });
              this.GrantTotalRecovedYTD=totalFRytd.toFixed(2),
              this.RecoveredAmountCount=totalFRytdCount,
              this.GrandTotalRMApproveYTD=totalRMAytd.toFixed(2);
              this.RMApprovalCount=totalRMAytdCount
              this.dashboardDetails=filteredZone;
              this.detailsLoading=false;
            }else{
              this.dashboardDetails=[];
              this.detailsLoading=false;
            }
          }
      // console.log("Searching data", this.hubzoneid, this.hubStateId, this.hubCityId, this.hubID)

    },

    //  getHubList(hubZoneID){
    //    let url = 'UpdateShipment/gethublist';
    //    if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;

    //    axios.get(apiUrl.api_url + url)
    //      .then((response) => {
    //          if(response.data.code ==200){
    //              this.hubList=response.data.data;
    //              this.hubList.sort(function(a, b){
    //               var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
    //               if (nameA < nameB) //sort string ascending
    //                return -1
    //               if (nameA > nameB)
    //                return 1
    //               return 0 //default return value (no sorting)
    //              });
    //          }
    //          else {
    //              this.hubList=[];
    //          }
    //      })
    //      .catch((httpException) => {
    //            this.$alertify.error("Hub List not found");
    //            console.error('exception is:::::::::', httpException)
    //      })
    //  },
     getHubZoneList(){
      //    axios.get(apiUrl.api_url + 'external/gethubzonelist')
      //    .then((response) => {
      //      this.hubZoneList = response.data.data;
      //      console.log("This.zoneList",this.hubZoneList)
      //    })
      //  .catch((httpException) => {
      //      console.error('exception is:::::::::',httpException)
      //  });
        var hubZone=[]
        this.hubAccessList.filter(element=>{
          const existingIndex = hubZone.findIndex(item => item.HubZoneId === element.HubZoneId);
              if (existingIndex !== -1) {
              hubZone[existingIndex] = element;
            } else {
              element['hubzoneid']=element.HubZoneId;
              hubZone.push(element );
            }
        });
        this.hubZoneList=hubZone;
     },

  getCenterTypeList() {
    axios.post(apiUrl.api_url + 'external/getCentreTypeList')
      .then((response) => {
        if (response.data.code == 200) {
          // console.log("response",response);
          this.CenterTypeList = response.data.data;
        }
        else {
          this.CenterTypeList = [];
          this.$alertify.error(response.data.message);

        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
  },
    clear(){
      this.getServiceCentreList("");
      this.hubzoneid=this.hubZoneList[0].HubZoneId;
      this.selectedHubZoneId = this.hubZoneList[0].HubZoneId;
      this.getDashboardDetails();'';
      this.hubname='';
      this.currentPage = 1;
      this.errors.clear();
      this.hubList = [];
      this.hubID='';
      this.hubStateId = ''
      // this.hubStateList=[],
      this.hubCitybyStateList = [],
      this.hubCityId = ''
      this.selectedStateId = '';
      this.selectedCityId = '';
      this.filteredHubList = [],
      this.filterHubList(),
      // this.modelValue = false
      this.usernames = ''
    },

    async getServiceCentreList(selectedCentreType) {
        console.log('ServiceCenterDropdown --------->>');
        this.selectedCenterType = selectedCentreType
        let getMasterHubListDetails = await this.getMasterHubList();
        console.log('getMasterHubListDetails ------>>', getMasterHubListDetails);
        // if(getMasterHubListDetails.length > 0) {
        //   let getFinalHubDetails = getMasterHubListDetails.map((masterHub) => {
        //     console.log('masterHub -->', masterHub);
        //     let getFilterResult = this.hubAccessList.filter((loginHub) => loginHub.HubID == masterHub.HubID);
        //     console.log('getFilterResult --------->>', getFilterResult);
        //     if (getFilterResult.length > 0) {
        //       masterHub.hubZoneId = loginHub.hubzoneid
        //       masterHub.hubZoneName = loginHub.hubzonename
        //       masterHub.hubStateId = loginHub.HubStateId
        //       masterHub.hubStateName = loginHub.HubState
        //       return masterHub;
        //     }
        //   })
          // console.log('getFinalHubDetails ------------>>', getFinalHubDetails);
        // } else {
        //   // add alertify
        //   return false;
        // }
        this.filterHubList()
      },
    getHubStateList(){

    var stateHub=[]
    this.hubAccessList.filter(element=>{
      const existingIndex = stateHub.findIndex(item => item.HubStateId == element.HubStateId);
          if (existingIndex !== -1) {
            stateHub[existingIndex] = element;
        } else {
          // element['stateid']=element.HubStateId;
          // element['statename']=element.HubState;
          stateHub.push(element);
        }
    });
    this.hubStateList=stateHub;
    },

    getCitiesbyState(event){
      this.selectedStateId = event.target.value;
      this.hubID=[];
      this.hubCityId='';
      this.filterHubList()
      const filtered=this.hubAccessList.filter(element=>(element.HubStateId==parseInt(event.target.value)));
      var cityHub=[]
      filtered.filter(element=>{
        const existingIndex = cityHub.findIndex(item => item.CityId == element.CityId);
            if (existingIndex !== -1) {
              cityHub[existingIndex] = element;
          } else {
            // element['stateid']=element.HubStateId;
            // element['statename']=element.HubState;
            cityHub.push(element);
          }
      });
      this.hubCitybyStateList=cityHub;

  },

  getHubsByCities(event){
    this.selectedCityId = event.target.value
    this.hubID=[];
    this.filterHubList()
  },
  getHubsByZoneId(event){
    this.selectedHubZoneId = event.target.value;
    this.hubID=[];
    this.hubCityId='';
    this.hubStateId='';
    this.filterHubList()
   },

   filterHubList() {
    // let data = {}
    // if (this.selectedHubZoneId != '') {
    //   data.zoneId = this.selectedHubZoneId
    // }
    // if (this.selectedStateId != '') {
    //   data.stateId = this.selectedStateId
    // }
    // if (this.selectedCityId != '') {
    //   data.cityId = this.selectedCityId
    // }
    // if (this.selectedCenterType != '') {
    //   data.centerType = [this.selectedCenterType]
    // } else {
    //   data.centerType = []
    // }
    // if (this.selectedAOR != '') {
    //   data.AOR = this.selectedAOR
    // }
    // axios.post(apiUrl.api_url + 'external/filterHubDetails', data)
    //   .then((response) => {
    //     this.filteredHubList = response.data.data;
    //     console.log("this.filteredHubList",this.filteredHubList)
    //   })
    //   .catch((httpException) => {
    //     console.error('exception is:::::::::', httpException)
    //   });


    this.filteredHubList=this.allhubList;
    var allhub=this.allhubList
      if(this.selectedHubZoneId!=''){
        var result=[];
              result=allhub.filter(h =>
                h.HubZoneId==this.selectedHubZoneId
              )
      }
      if(this.selectedHubZoneId!='' && this.selectedStateId!=''){
        result=allhub.filter(h =>
          h.HubZoneId==this.selectedHubZoneId &&
          h.HubStateId==this.selectedStateId
        )
      }
      if(this.selectedHubZoneId!='' && this.selectedStateId!='' && this.selectedCityId){
        result=allhub.filter(h =>
          h.HubZoneId==this.selectedHubZoneId &&
          h.HubStateId==this.selectedStateId &&
          h.CityId==this.selectedCityId
        )
      }
      // if(this.selectedHubZoneId!='' && this.selectedStateId!='' &&
      //   this.selectedCityId !=''&& this.selectedAOR != ''){
      //   result=allhub.filter(h =>
      //     h.HubZoneId==this.selectedHubZoneId &&
      //     h.HubStateId==this.selectedStateId &&
      //     h.CityId==this.selectedCityId &&
      //     h.soc===this.selectedAOR
      //   )
      // }
//       if(this.selectedHubZoneId!='' && this.selectedStateId!='' &&
//         this.selectedCityId !=''&& this.selectedAOR != '' && this.selectedCenterType != ''){
//       result=allhub.filter(h =>
//         h.HubZoneId==this.selectedHubZoneId &&
//         h.HubStateId==this.selectedStateId &&
//         h.CityId==this.selectedCityId &&
//         h.soc===this.selectedAOR &&
//         h.CenterType===this.selectedCenterType
//       )
//  }
      this.filteredHubList=result;
  },
  getMasterHubList() {
    return new Promise((resolve,reject) => {
      try {
      let data = {
        centerType : []
      }
        axios.post(apiUrl.api_url + 'external/filterHubDetails', data)
          .then((response) => {
            // this.masterHubList = response.data.data;
            let allHubdata = response.data.data;
            let filteredHubList = allHubdata.filter(o => this.hubAccessList.some(({HubID}) => o.HubID === HubID));
            let mergedArray = this.hubAccessList.map(obj1 => {
              let obj2 = filteredHubList.find(obj => obj.HubID === obj1.HubID);
              return Object.assign({}, obj1, obj2);
          });
            this.filteredHubList=mergedArray
            this.allhubList=this.filteredHubList;
            console.log("this.filteredHubList",this.allhubList)
            resolve(this.allhubList)
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
            resolve([])
          });
      } catch(e) {
        console.log('Error', e);
        resolve([])
      }
    })
  },

    handleSelectAll() {
      this.hubID = this.selectAll ? this.filteredHubList.map(option => option) : [];
    },

    getDashboardDetails(){
      this.detailsLoading=true;
      let reqdata = {
        userid : this.localuserid
      }
      axios.post(apiUrl.api_url + 'shipmentLost/LostDashboard/search', reqdata)
          .then((response) => {
            if(response.data.code == 200){
              // console.log(response.data,"->>>>>>>>>>")
              this.overAllDetails=response.data;
              var approvalDetails= response.data.data;

              approvalDetails.map(element => {
                //RMApproveCalculated
                element['RMALastMonth'] = element.data.RMApproveCalculated.getRMApprovePendingCountlast1stMonth ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountlast1stMonth.totalDebitAmount :
                  '0';
                element['RMA2ndLastMonth'] = element.data.RMApproveCalculated.getRMApprovePendingCountlast2ndMonth ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountlast2ndMonth.totalDebitAmount :
                  '0';
                element['RMA3rdLastMonth'] = element.data.RMApproveCalculated.getRMApprovePendingCountlast3rdMonth ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountlast3rdMonth.totalDebitAmount :
                  '0';
                element['RMAmtd'] = element.data.RMApproveCalculated.getRMApprovePendingCountcurrentMonthPeriod ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountcurrentMonthPeriod.totalDebitAmount :
                  '0';
                element['RMAytd'] = element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod.totalDebitAmount :
                  '0 ';
                element['RMAytdCount'] = element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod ?
                  element.data.RMApproveCalculated.getRMApprovePendingCountytdPeriod.count :
                  '0 ';

                //FullyRecoveredCalculated
                element['FRLastMonth'] = element.data.FullyRecoveredCalculated.getFullyRecoveredlast1stMonth ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredlast1stMonth.totalRecoveredAmount :
                  '0';
                element['FR2ndLastMonth'] = element.data.FullyRecoveredCalculated.getFullyRecoveredlast2ndMonth ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredlast2ndMonth.totalRecoveredAmount :
                  '0';
                element['FR3rdLastMonth'] = element.data.FullyRecoveredCalculated.getFullyRecoveredlast3rdMonth ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredlast3rdMonth.totalRecoveredAmount :
                  '0';
                element['FRmtd'] = element.data.FullyRecoveredCalculated.getFullyRecoveredcurrentMonthPeriod ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredcurrentMonthPeriod.totalRecoveredAmount :
                  '0';
                element['FRytd'] = element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod.totalRecoveredAmount :
                  '0';
                element['FRytdCount'] = element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod ?
                  element.data.FullyRecoveredCalculated.getFullyRecoveredytdPeriod.count :
                  '0';
              })
              this.dashboardDetails=approvalDetails;
              this.temp=approvalDetails;
              this.searchData();
              this.detailsLoading=false;

            }else if(response.data.code == 204) {
              this.detailsLoading=false;
              this.$alertify.error("No Pending Approval");
            }else if(response.data.code == 202) {
              this.detailsLoading=false;
              this.$alertify.error(response.data.message);
            }else{
              this.detailsLoading=false;
              this.$alertify.error(response.data.message);
            }
          })
        .catch((httpException) => {
            console.error('exception is:::::::::',httpException)
        });
    },

    prevPage() {
      if (this.currentPage > 1) {
          this.currentPage--;
      }
      },
      nextPage() {
          if (this.currentPage < this.totalPages) {
              this.currentPage++;
          }
      }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/RMApproveDashboard/RMApproveDashboard.component.js